import React from 'react'
import ErrorIcon from '@material-ui/icons/Error';
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

function WorkableIconErrorButton(
    {
        tooltip,
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={ErrorIcon}
        {...props}
    />
}

WorkableIconErrorButton.propTypes = {
    expanded: PropTypes.bool,
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconErrorButton;